"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchLeadRotation = matchLeadRotation;
const leadTaxonomy_1 = require("./leadTaxonomy");
function matchLeadRotation(rules, lead) {
    // Precedence we walk:
    //   1. service + dealType + office
    //   2. service + dealType
    //   3. service + office
    //   4. service
    //   5. office
    //   6. company-wide (no match constraints)
    //
    // We use rules.cascadePriority order if set, else this default.
    const priority = rules.cascadePriority ?? leadTaxonomy_1.DEFAULT_CASCADE_PRIORITY;
    for (const tier of priority) {
        for (const r of rules.rotations) {
            const m = r.match;
            const matched = (() => {
                switch (tier) {
                    case 'service+dealType+office':
                        return (m.serviceCategory === lead.serviceCategory &&
                            m.dealType === lead.dealType &&
                            m.officeId === lead.officeId &&
                            !!lead.serviceCategory && !!lead.dealType && !!lead.officeId);
                    case 'service+dealType':
                        return (m.serviceCategory === lead.serviceCategory &&
                            m.dealType === lead.dealType &&
                            !m.officeId &&
                            !!lead.serviceCategory && !!lead.dealType);
                    case 'service+office':
                        return (m.serviceCategory === lead.serviceCategory &&
                            !m.dealType &&
                            m.officeId === lead.officeId &&
                            !!lead.serviceCategory && !!lead.officeId);
                    case 'service':
                        return (m.serviceCategory === lead.serviceCategory &&
                            !m.dealType &&
                            !m.officeId &&
                            !!lead.serviceCategory);
                    case 'office':
                        return (!m.serviceCategory &&
                            !m.dealType &&
                            m.officeId === lead.officeId &&
                            !!lead.officeId);
                    case 'company':
                        return !m.serviceCategory && !m.dealType && !m.officeId;
                }
                return false;
            })();
            if (matched)
                return r;
        }
    }
    return null;
}
